<template>
    <div class="image-loading-box noselect">
        <div class="icon-box">
        <i></i>
        <div class="icon-text">{{$t("FreeWatermarkRemover")}}</div>
        </div>
        <div class="loading-box show-message-box">
        <div class="loading-progress"><i style="width: 0%;"></i></div>
        <div class="loading-text">{{$t("Processing")}}</div>
        </div>
        <div class="load-error-box show-message-box">
        <img src="../assets/images/fail.png" alt="Fail">
        <div class="error-text"></div>
        <div class="button-group">
            <label for="upload">
            <div class="confirm">{{$t("NewImage")}}</div>
            </label>
            <div class="cancel">{{$t("Cancel")}}</div>
        </div>
        <div class="feed-back-box"><a href="javascript:void(0)" class="feed-back-link">{{$t("FailureFeedback")}}</a></div>
        </div>
        <div class="load-warning-box show-message-box">
        <div class="warning-icon"><img src="../assets/images/warning.png" alt="Warning"></div>
        <div class="warning-text"></div>
        <div class="button-group">
            <div class="confirm">{{$t("Retry")}}</div>
            <div class="cancel">{{$t("Cancel")}}</div>
        </div>
        <div class="feed-back-box"><a href="javascript:void(0)" class="feed-back-link">{{$t("FailureFeedback")}}</a></div>
        </div>
        <div class="show-alert show-message-box">
        <div class="warning-icon"><img src="../assets/images/warning.png" alt="Warning"></div>
        <div class="warning-text"></div>
        <div class="button-group">
            <div class="confirm">{{$t("Yes")}}</div>
            <div class="cancel">{{$t("No")}}</div>
        </div>
        <div class="feed-back-box"><a href="javascript:void(0)" class="feed-back-link">{{$t("FailureFeedback")}}</a></div>
        </div>
        <div class="down-alert-box show-message-box">
        <div class="warning-icon rotate">
            <img class="noRemove" src="../assets/images/processing.svg" alt="Processing">
            <img class="down" src="../assets/images/downloading.svg" alt="Downloading">
            <img class="load" src="../assets/images/rotate.svg" alt="Rotate">
        </div>
        <div class="info"></div>
        <i class="close"></i>
        </div>
        <div class="open-alert-box show-message-box">
        <div class="warning-icon rotate">
            <img src="../assets/images/history-open.svg" alt="Open">
            <img class="load" src="../assets/images/rotate.svg" alt="Rotate">
        </div>
        <div class="info"></div>
        <i class="close"></i>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>


.image-loading-box{
    border-radius: 18px;
    overflow: hidden;
    max-width: 450px;
    margin: 0px;
    width: 96%;
    position: fixed;
    top: 50%;
    height: auto;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    z-index: 6;
    background: #fff;
    display: block;
    box-shadow: 0 0 30px #00274266;
    display: none;
    padding-bottom: 40px;
}
.show-message-box{
    width: 100%;
    height: 100%;
    display: none;
    overflow: hidden;
    margin: auto;
}
.error-icon{
    width: 100px;
    height: 100px;
    border: 10px solid #F5A73F;
    border-radius: 100%;
    font-size: 60px;
    text-align: center;
    line-height: 100px;
    color: #F5A73F;
    font-weight: bold;
    margin:60px auto 0;
}
.loading-icon{
    width: 100px;
    height: 100px;
    /* border: 10px solid #3C6AE8;
    border-radius: 100%; */
    font-size: 30px;
    text-align: center;
    line-height: 100px;
    color: #3C6AE8;
    /* font-weight: bold; */
    margin: 60px auto 0 auto;
    background-image: url('/images/online-bg-remover/loading.gif');
}
.warning-icon{
    width: 100px;
    height: 100px;
    margin: 40px auto 0 auto;
}
.image-loading-box.active{background: none;box-shadow: none;min-height: auto;padding-bottom: 0px;}
.image-loading-box.active .icon-box{display: none;}
.loading-box{background: rgba(0, 0, 0, .3);padding-bottom: 20px;border-radius: 20px;max-width: 280px;width: 100%;}
.loading-progress{height: 14px;border-radius: 30px;width: 170px;position: relative;border: 2px solid #fff;box-sizing: border-box;margin: 50px auto 0px;}
.loading-progress i{background: #fff;display: block;height: 14px;position: absolute;top: -2px;left: -1px;padding: 0;margin: 0;border-radius: 30px;width: 13px;}
.loading-box .loading-text{margin-top: 15px;color: #fff;font-size: 16px;}
.load-error-box>img{margin: auto;display: block;margin-top: 50px;}
.show-message-box{
    width: 100%;
    height: 100%;
    display: none;
    overflow: hidden;
}
.warning-icon img{
    width: 100%;
    height: 100%;
}
.error-text{
    width: 80%;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin: 20px auto 0;
    color: #333;
}
.loading-text{
    width: 80%;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin: 40px auto 0 auto;
    color: #333;
}
.show-message-box .info,.warning-text{
    width: 80%;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin: 10px auto 0 auto;
    color: #333;
}
.button-group{
    text-align: center;
    height: auto;
    margin: 20px auto 0;
    overflow: hidden;
}
.button-group div{
    min-width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 30px;
    font-size: 18px;
    border: 1px solid #21a1f2;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    float: none !important;
    display: inline-block;
    margin: 0 10px;
}
.button-group div:hover{
    background-color: #33c3f3;
    border-color: #33c3f3;
    color: white;
}
.retry, .confirm{
    float: left;
    background-color: #21a1f2;
    color: white;
}
.cancel{
    float: right;
    background-color: white;
    color: #21a1f2;
}
.cancel-upload{
    width: 120px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    border-radius: 36px;
    font-size: 18px;
    cursor: pointer;
    margin: 30px auto 0px;
    background-color: #21a1f2;
    color: white;
}
.cancel-upload:hover{
    background-color: #33c3f3;
}
a.jump-link{
    color: #ff9602 !important;
    text-decoration: underline;
}

.pensize-box{
    position: relative;
    width: 180px;
    height: 10px;
    border: #D9D9D9 !important;
    overflow: visible !important;
    cursor: pointer; 
}
.pensize-grey-box{
    width: 100%;
    height: 2px;
    background-color: #D9D9D9;
    margin-top: 3px;
}
.pensize-dot{
    position: absolute;
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #21a1f2;
    z-index: 10;
    border-radius: 100%;
    top: 0px;
    left: 16px;
    box-shadow: 0 0 4px 1px #21a1f2;
}

.alert-modal-box{
    width: 100%;
    height: 100%;
    max-width: 500px;
    max-height: 300px;
    background-color: white;
    border-radius: 20px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    box-shadow: 0 0 30px #00274266;
    display: none;
}
.alert-modal-box .confirm-icon{
    width: 60px;
    height: 60px;
    margin: 40px auto;
}
.alert-modal-box .confirm-text{
    width: 80%;
    text-align: center;
    line-height: 20px;
}
.alert-modal-box .confirm-button-group{
    width: 60%;
    overflow: hidden;
    margin: 50px auto;
}
.confirm-button-group div{
    width: 140px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: white;
    border-radius: 15px;
    background-color: #21a1f2;
    cursor: pointer;
    border: 1px solid #21a1f2;
}
.confirm-button-group div:hover{
    background-color: #33c3f3;
    border-color: #33c3f3;
}
.confirm-button-group .confirm-back{
    float: left;
}
.over-limit-upload .confirm-back{
    float: none;
}
.confirm-button-group .cancel-back{
    float: right;
    background-color: white;
    color: #21a1f2;

}
.confirm-button-group .cancel-back:hover{
    color: white;
  
}
.image-loading-box .icon-box{
    position: absolute;
    top: 10px;
    left: 15px;
}
.image-loading-box .icon-box i{
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: -7px;
    margin-right: 6px;
    background: url(../assets/images/icon.png) 0 0 no-repeat;
    background-size: 24px 24px;
}
.image-loading-box .icon-box .icon-text{
    display: inline-block;
    vertical-align: middle;
    color: #21a1f2;
}
.image-loading-box .feed-back-box{
    position: absolute;
    right: 0px;
    bottom: 10px;
    color: #3A81EA;
    text-decoration: underline;
    padding-right: 20px;
}
.image-loading-box .feed-back-box a{
    color: #3A81EA;
}
.color-picker{
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.transparent-bg{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url(/images/online-bg-remover/bg.png);
    background-size: 100%;
    box-shadow: 0 0 4px 1px #0000003d;
    display: none;
}
.show-message-box .close{width: 20px;height: 20px;background: url(../assets/images/close.svg);position: absolute;top: 10px;right: 10px;cursor: pointer;}
.show-message-box .close:hover{background: url(../assets/images/close-h.svg);}
.show-message-box .rotate{position: relative;}
.show-message-box .rotate img.load{position: absolute;top: 0px;left: 0px;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;}

</style>